import validate from "/home/nodejs/kare-backoffice-v2/source/node_modules/.pnpm/nuxt@3.12.4_@types+node@20.14.15_eslint@8.57.1_typescript@5.8.3_vite@5.4.14_vue-tsc@3.0.3/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/home/nodejs/kare-backoffice-v2/source/middleware/auth.global.ts";
import init_45global from "/home/nodejs/kare-backoffice-v2/source/middleware/init.global.ts";
import manifest_45route_45rule from "/home/nodejs/kare-backoffice-v2/source/node_modules/.pnpm/nuxt@3.12.4_@types+node@20.14.15_eslint@8.57.1_typescript@5.8.3_vite@5.4.14_vue-tsc@3.0.3/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  init_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "purchase-webhooks": () => import("/home/nodejs/kare-backoffice-v2/source/middleware/purchase-webhooks.ts"),
  "team-product-index": () => import("/home/nodejs/kare-backoffice-v2/source/middleware/team-product-index.ts")
}